import {
  AddLocationRounded,
  AreaChartRounded,
  ArticleRounded,
  ChevronLeftRounded,
  ChevronRightRounded,
  DashboardOutlined,
  ExitToAppRounded,
  FileOpenRounded,
  HomeRounded,
  LocationCityRounded,
  LogoutRounded,
  MenuRounded,
  PersonRounded,
  WhereToVoteRounded,
} from "@mui/icons-material";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import {
  CssBaseline,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Popover,
  Stack,
  styled,
  Toolbar,
  Typography,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import Api from "../api/RestApi.json";
import axios from "axios";

const drawerWidth = 240;

const navItems = [
  {
    title: "Dashboard",
    link: "/",
    icon: <HomeRounded />,
  },
  {
    title: "Artikel & Berita",
    link: "/artikel",
    icon: <ArticleRounded />,
  },
  {
    title: "Artikel Kecamatan",
    link: "/daerah",
    icon: <AreaChartRounded />,
  },
  {
    title: "Potensi",
    link: "/potensi",
    icon: <WhereToVoteRounded />,
  },
  {
    title: "Peluang",
    link: "/peluang",
    icon: <AddLocationRounded />,
  },
  {
    title: "Infrastruktur",
    link: "/infrastruktur",
    icon: <LocationCityRounded />,
  },
  {
    title: "File",
    link: "/file",
    icon: <FileOpenRounded />,
  },
  {
    title: "Pengguna",
    link: "/pengguna",
    icon: <PersonRounded />,
  },
  {
    title: "Komponen",
    link: "/komponen",
    icon: <DashboardOutlined />,
  },
];

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),

  backgroundColor: "#D9091B",

  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  backgroundColor: "#D9091B",

  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        backgroundColor: "#D9091B",
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(["width", "margin"], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  variants: [
    {
      props: ({ open }) => open,

      style: {
        ...openedMixin(theme),
        "& .MuiDrawer-paper": openedMixin(theme),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        ...closedMixin(theme),
        "& .MuiDrawer-paper": closedMixin(theme),
      },
    },
  ],
}));

export default function AppBarCustom(params) {
  const goTo = useNavigate();

  const theme = useTheme();
  const openDrawer = localStorage.getItem("openDrawer") == "true";
  const [open, setOpen] = React.useState(openDrawer);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const openPopover = Boolean(anchorEl);
  const id = openPopover ? "simple-popover" : undefined;

  const handleDrawerOpen = () => {
    localStorage.setItem("openDrawer", true);

    setOpen(true);
  };

  const handleDrawerClose = () => {
    localStorage.setItem("openDrawer", false);

    setOpen(false);
  };

  const handleClickPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePopover = () => {
    setAnchorEl(null);
  };

  const logoutHanlder = async () => {
    const data = {
      token: localStorage.getItem("token"),
    };
    try {
      var response = "";
      response = await axios.post(Api.logout, data);
      // setValidation(data.nama + ' Berhasil Ditambahkan!');
      console.log(response.data);
    } catch (error) {
      console.log(error.response.data);
    }

    localStorage.removeItem("token");
    setTimeout(() => {
      goTo(0);
    }, 500);
  };

  return (
    <div>
      <CssBaseline />
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={[
              {
                marginRight: 5,
              },
              open && { display: "none" },
            ]}
          >
            <MenuRounded />
          </IconButton>
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            alignItems={"center"}
            width={"100%"}
          >
            <Typography variant="h6" noWrap component="div">
              {params.selected}
            </Typography>
            <IconButton
              onClick={openPopover ? handleClosePopover : handleClickPopover}
            >
              <LogoutRounded sx={{ color: "white" }} />
            </IconButton>
          </Stack>
        </Toolbar>
      </AppBar>

      <Popover
        id={id}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClosePopover}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <List>
          <ListItem>
            <ListItemButton onClick={logoutHanlder}>
              <ListItemIcon>
                <ExitToAppRounded />
              </ListItemIcon>
              <ListItemText>Keluar</ListItemText>
            </ListItemButton>
          </ListItem>
        </List>
      </Popover>

      <Drawer variant="permanent" open={open}>
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction == "rtl" ? (
              <ChevronRightRounded />
            ) : (
              <ChevronLeftRounded sx={{ color: "white" }} />
            )}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {navItems.map((item, index) => (
            <ListItem
              key={item.title}
              disablePadding
              sx={{
                display: "block",
                bgcolor:
                  item.title == params.selected ? "#18810aff" : "inherit",
              }}
            >
              <ListItemButton
                onClick={(e) => {
                  goTo(item.link);
                }}
                sx={[
                  {
                    minHeight: 48,
                    px: 2.5,
                  },
                  open
                    ? {
                        justifyContent: "initial",
                      }
                    : {
                        justifyContent: "center",
                      },
                ]}
              >
                <ListItemIcon
                  sx={[
                    {
                      minWidth: 0,
                      justifyContent: "center",
                    },
                    open
                      ? {
                          mr: 3,
                        }
                      : {
                          mr: "auto",
                        },
                  ]}
                >
                  <Typography
                    color={item.title == params.selected ? "white" : "black"}
                  >
                    {item.icon}
                  </Typography>
                </ListItemIcon>
                <ListItemText
                  sx={[
                    open
                      ? {
                          opacity: 1,
                        }
                      : {
                          opacity: 0,
                        },
                  ]}
                >
                  <Typography
                    flexWrap={"wrap"}
                    color={item.title == params.selected ? "white" : "black"}
                    fontWeight={item.title == params.selected ? "Bold" : ""}
                  >
                    {item.title}
                  </Typography>
                </ListItemText>
              </ListItemButton>
            </ListItem>
          ))}
        </List>
        <Divider />
      </Drawer>
    </div>
  );
}
